import React, { useEffect, useState } from 'react';
import Page from "../../../components/Page";
import EventListSection from "../../../components/NewDesign/Event/EventListSection"
import { Tab, Tabs } from 'react-bootstrap';
import useLogin from '../../../custom-hooks/useLogin';
import EventsCalendar from '../../../components/Calendar/EventsCalendar';

const LearnMCSessionPage = () => {
  const [key, setKey] = useState("upComingEvents");
  const { isLoggedIn } = useLogin();
  const [selectedSessionFromHome, setSelectedSessionFromHome] = useState({});
  const [selectedSessionPos, setSelectedSessionPos] = useState(0)

  useEffect(()=>{

    return(()=>{
      setKey("upComingEvents")
    })
  },[])
  return (
    <>
      <div className='contsection'>
        <Tabs
          underline
          activeKey={key}
          onSelect={(k) => {
            // setIsFetching(true)
            console.log("selectKey: ", k);
            setKey(k);

          }}
        >
          <Tab eventKey={"upComingEvents"} title="Sessions">
              
          </Tab>
          {isLoggedIn && (
            <Tab eventKey={"myEvents"} title="My sessions">
              
            </Tab>
          )}
        </Tabs>
        {key==="upComingEvents"?<EventsCalendar isHome={false} isLearn={true}
        marketingDateRange={null}
        setSelectedSessionFromHome={setSelectedSessionFromHome}
        selectedSessionPos={selectedSessionPos}
        setSelectedSessionPos={setSelectedSessionPos} />:
        <EventListSection />}
      </div>
    </>
  )
}

export default LearnMCSessionPage
